/**
 * This is an auto generated file - do not modify manually!
 * Line Heights are fetched via Figma api
 */
var lineHeights = {
  normal: 1.5,
  tight: 1.33,
  loose: 1.8
};
export { lineHeights };